import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="d-sm-flex justify-content-center justify-content-sm-between">
        <span className="text-muted d-block text-center text-sm-left d-sm-inline-block">
          Copyright © Bhagubai Changu Thakur College of Law
        </span>
      </div>
    </footer>
  );
};

export default Footer;
